module.exports = __webpack_public_path__ + "img/who-we-are.99b12694.webp";